import React from "react";
import HibuButton from "./HibuButton";
import "./Review.scss";
import StarRating from "./StarRating";

const ratingNum = (rating) => {
  if (rating > 0) {
    return (
      <span>
        (<span itemProp="ratingValue">{rating.toFixed(1)}</span>)
      </span>
    );
  }
};

const ReviewTags = ({ merchant, writeDisable }) => {
  const allow_review = writeDisable ? (
    ""
  ) : merchant.state === "cancelled" ? (
    ""
  ) : (
    <HibuButton url={merchant.surveyUrl} text="Write a Review" />
  );
  return (
    <div className="summary">
      <div className="content">
        <StarRating rating={merchant.averageRating} />
        {merchant.averageRating > 0.0 && <div className="meta">{ratingNum(merchant.averageRating)} Overall Rating</div>}
      </div>
      {allow_review}
    </div>
  );
};

export default ReviewTags;



// WEBPACK FOOTER //
// ./src/components/ReviewTags.jsx